import React, {useState, useRef} from 'react'
import { Container, Row, Col, Button, Card, Nav, Table } from "react-bootstrap";
import { Link } from 'react-router-dom';
import './cij.css'
import './zartecbutton.css'
import img2 from '../Components/Images/TTO/TTO1071.png'
import img3 from '../Components/Images/TTO/TTO1072.png'
import img4 from '../Components/Images/TTO/TTO1073.png'
import img5 from '../Components/Images/TTO/TTO1074.png'

import img7 from '../Components/Images/applications/tto-1.png'
import img8 from '../Components/Images/applications/tto-2.png'
import img9 from '../Components/Images/applications/tto-3.png'
import { Bold } from 'lucide-react';
function TTO107I() {
    const [activeTab, setActiveTab] = useState('specifications');

    const secondSectionRef = useRef(null);
    
        const scrollToSection = () => {
        secondSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
      };

    const productsI9 = [
            {
              id: 1,
              model: "107 x 75I - Magnetic Printer",
              description: "Compact design, IP65 protection, and advanced ink modulation for consistent printing.",
              image: img2
            },
            {
              id: 2,
              
              model: "107 x 125I TTO Printer",
              description: "Enhanced ink system stability, IP65 protection, consistent printing and user-friendly interface.",
              image: img3
            },
            {
              id: 3,
              
              model: "107 x 75I XL TTO Printer",
              description: "Advanced printhead with twin-valve technology, auto-cleaning system, and IP65 protection.",
              image: img4
            },
            
              {
                id: 4,
                
                model: "107 C LH or RH TTO Printer",
                description: "Advanced printhead with twin-valve technology, auto-cleaning system, and IP65 protection.",
                image: img5
              }
          ];

           const images = [
              { id: 1, src: img7, alt: 'Cable' },
              { id: 2, src: img8, alt: 'Metal' },
              { id: 3, src: img9, alt: 'Pipe' },
              
            ];

          

          const applications1 = [
            {
              id: 1,
              image:img4,
              name: "Plastic",
              
            },
        ];
        const featuresContent = (
            <div style={{paddingLeft:"20px", paddingTop:"10px", paddingBottom:"10px"}}>
              <h4 style={{marginTop:"10px"}}>Technical Features</h4>
              <div>
                
               
                <ul className='p-3' style={{ listStyle: "none", paddingLeft: 0 }}>
                    {[
                        "107mm x 76mm for Intermittent model print area",
                        "107mm x 125mm for Intermittent model print area",
                        "107mm x 76mm for Intermittent model print area",
                        "107mm x 125mm(107mm x 250mm Optional) Continuous mode print area",
                        "600 m. Ribbon Capacity.",                      
                        "Resolution 300 dpi (12 dots / mm)",                         
                        "Print Speed 10-550 mm/sec.",                        
                        "7 inch touch panel color control screen." ,                       
                        "90 °, 180 °, 270 ° rotate features of the templates.", 
                        "Memory: 5000 Templates can be stored in the control screen memory.",
                        "Power Supply: 100/240V 50/60 Hz.", 
                        " Programming: Real Date/Time, Text, 1D/2D Barcodes, Logo, Counter (Serial No), Shift Code, Shape, Currency, Database Support, Table Creation Support.", 
                        "Barcode Types: 1D Barcodes ( EAN-13, EAN-8, CODE 128, CODE 39, CODABAR, ITF 2of5, ITF 14, UPCA, UPC-E…), 2D Barcodes (Datamatrix, QR Code, PDF417, Aztec code…), GS-1 Barcodes ( GS1-128, GS1-Datamatrix, GS1-Databar Barcodes)",
                        "Communication: RS-232, Ethernet, USB",
                        "PC Programme: Sayasis S20 (All Features Free)"
   
                    ].map((item, index) => (
                    <li key={index} style={{ position: "relative", paddingLeft: "25px", marginBottom: "8px" }}>
                    <span style={{ 
                        position: "absolute", 
                        left: 0,
                        color: "#00663b", // your brand color
                        fontWeight: "bold",
                        fontSize:"17px",
                        
                    }}>*</span><span
                  
                    >{item}</span>
                        
                        </li>
                        ))}

                </ul>
              </div>
            </div>

        );

        const applicationsContent = (
            <div style={{marginLeft:"10px", marginRight:"10px"}} className='pt-5'>
              <h2 className="text-center mb-4 " style={{fontSize:"25px", fontFamily:"sans-serif"}}>Our Applications</h2>
            
                 <Row className="g-4 mb-5">
                        {images.map((image) => (
                          <Col key={image.id} xs={12} sm={6} md={4}>
                            <div className="image-card">
                              <img 
                                src={image.src} 
                                alt={image.alt}
                                className="img-fluid rounded"
                                style={{maxHeight:"300px"}}
                              />
                              <div className="image-overlay">
                                <p className="image-caption">{image.alt}</p>
                              </div>
                            </div>
                          </Col>
                        ))}
                      </Row>
            
            </div>
           
            ); 
            
        const technicalContent=(
            <div style={{paddingLeft:"20px", paddingTop:"10px", paddingBottom:"10px"}}>
              <h4 style={{marginTop:"10px"}}>Key Features</h4>
              <div>
                <p className='p-3 text-justify'>
                The high performance, cost-effective SAVEMA Thermal Transfer Overprinters (TTOs) are versatile enough for printing fixed and variable text, data, and graphics. It is ideal for reproducing bar codes, real-time, sell-by dates, batch numbers, prices, source codes and much more. Two-component models of brackets (Intermittent & Continuous)  can be easily integrated into machines such as vertical and horizontal form-fill-seal systems, primary labelers, thermoformers, and overwrapping equipment. The units are suitable for all continuous applications within the food, pharmaceutical cosmetics, and automobile spare parts industries and have the capability to code all kinds of 1D/2D barcodes and Datamatrix codes.
                </p>
               
                <ul className='p-3' style={{ listStyle: "none", paddingLeft: 0 }}>
                    {[
                        "Robust mechanical design needs no maintenance.",
                        "For 107 x 75 I - Magnetic Printer 107mm – 75mm for Intermittent print area",
                        "For 107 x 125 I TTO Printer 107mm – 125mm for Intermittent print area",
                        "For 107 x 75 I XL TTO Printer 107mm – 76mm for Intermittent print area",
                        "For 107 C LH or RH TTO Printer 53mm – 125mm for Continuous print area",
                        "600 m. Ribbon Capacity.",
                        "300 dpi (12 dots/mm) Print Quality.",
                        "50 - 400mm per/second print speed.",
                        "Template Design PC Program Sayasis S20 all features are free of charge.",
                        "Large memory for all label formats to be stored locally.",
                        "The USB can be used to transfer messages between printers and through computer too."
   
                    ].map((item, index) => (
                    <li key={index} style={{ position: "relative", paddingLeft: "25px", marginBottom: "8px" }}>
                    <span style={{ 
                        position: "absolute", 
                        left: 0,
                        color: "#00663b", // your brand color
                        fontWeight: "bold",
                        fontSize:"17px",
                        
                    }}>•</span><span
                  
                    >{item}</span>
                        
                        </li>
                        ))}

                </ul>
              </div>
            </div>
        )
        
            const brochuresContent = (
                <div>
                  <h4>Available Brochures</h4>
                  </div>
            );
          const renderTabContent = () => {
            let content;
            
            switch (activeTab) {
              case 'specifications':
                content = technicalContent;
                break;
              case 'features':
                content = featuresContent;
                break;
              case 'applications':
                content = applicationsContent;
                break;
              default:
                content = null;
            }
            
            return <div className="tab-content-animation">{content}</div>;
          };
    
  return (
    <div>
      <section>
    <Container className="py-5">
      <h2 className="mb-4 cijh2">107 I and C Thermal Transfer Over Printer</h2>
      <Row>
        {productsI9.map(product => (
          <Col lg={4} md={6} className="mb-4" key={product.id}>
            <Card className="h-100 border-light shadow-sm rounded-3">
              <Card.Body className="d-flex flex-column">
                <div className=" mb-2" 
                style={{
                  background: "linear-gradient(135deg, #0A6E54 0%, #1B4B89 100%)",
                  WebkitBackgroundClip: "text",
                  backgroundClip: "text",
                  color: "transparent",
                  fontWeight:"bold",
                  display: "inline-flex",
                  alignItems: "center",
                  textDecoration: "none",
                  marginTop: "auto",
                }}>
                  {product.model}</div>
                
                <p className="text-muted">{product.description}</p>
                
                <button 
                  className={`zartec-btn zartec-btn-primary zartec-btn-small`} 
                  onClick={scrollToSection}
                  >
                  Get Product
                  </button>
              </Card.Body>
              <div className="p-3 text-center">
                <img src={product.image} alt={product.model} className="img-fluid" style={{ maxHeight: '200px' }} />
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
    </section>
    <section ref={secondSectionRef}>
    <div className="product-navbar-container mb-4">
  <Nav className="nav-tabs-custom d-flex justify-content-center">
    <Nav.Item className="flex-fill text-center">
      <Nav.Link 
        className={`px-4 py-3 ${activeTab === 'specifications' ? 'active' : ''}`}
        onClick={() => setActiveTab('specifications')}
      >
        <span className="nav-text">Key Features</span>
      </Nav.Link>
    </Nav.Item>
    <Nav.Item className="flex-fill text-center">
      <Nav.Link 
        className={`px-4 py-3 ${activeTab === 'features' ? 'active' : ''}`}
        onClick={() => setActiveTab('features')}
      >
        <span className="nav-text">Technical Specification</span>
      </Nav.Link>
    </Nav.Item>
    <Nav.Item className="flex-fill text-center">
      <Nav.Link 
        className={`px-4 py-3 ${activeTab === 'applications' ? 'active' : ''}`}
        onClick={() => setActiveTab('applications')}
      >
        <span className="nav-text">Applications</span>
      </Nav.Link>
    </Nav.Item>
  </Nav>
</div>
<div className="border border-top-0 p-0 bg-white">
  {renderTabContent()}
</div>
    </section>
    </div>
  )
}

export default TTO107I

